import React from "react";
import './css/404.css';


const PageNotFound = () => {

    return (
        <div className="page-not-found-body">
            <h1>Oops! Looks like your Karma caught up with you...</h1>
            <p>We can't find the page you're looking for</p>
        </div>
    );
};

export default PageNotFound;
